import React from 'react';
import { UNIT } from 'src/settings/settings';
import { currency, effectiveDisplayUnit, formatShares } from 'src/utils/utils';
import words from 'src/utils/words';
import { Case, Switch } from 'src/components/Shared/Switch';
import { Fund } from '../types';

interface ExchSummFromAmtProps {
  exchangeUnit: unknown;
  fund: Fund;
}

const ExchangeSummaryFromAmount: React.FC<ExchSummFromAmtProps> = ({
  exchangeUnit,
  fund,
}) => (
  <Switch test={effectiveDisplayUnit(fund.grossUnit, exchangeUnit)}>
    <Case value={UNIT.ALL_SHARES}>All {words.Shares}</Case>

    <Case value={UNIT.DOLLARS}>
      {currency(fund.grossAmountDollars)} Dollars
    </Case>

    <Case value={UNIT.PERCENT}>
      {formatShares((fund.grossAmount * fund.shares) / 100, words.Share)}
    </Case>

    <Case value={UNIT.SHARES}>
      {formatShares(fund.grossAmountDollars / fund.sharePrice, words.Share)}
    </Case>
  </Switch>
);

export default ExchangeSummaryFromAmount;
